import React, { useState } from 'react';
import { useStoryId } from '../hooks/useStoryId';
import { bookmarksApi } from '../api/bookmarks';
import BookmarkList from '../components/Bookmarks/BookmarkList';
import CreateSynthesis from '../components/Bookmarks/CreateSynthesis';

function BookmarksPage() {
  const { storyId } = useStoryId();
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleCreateSynthesis = async (title, content, category) => {
    if (!storyId) {
      throw new Error('No story selected');
    }

    await bookmarksApi.createSynthesis(storyId, {
      user_title: title,
      content: content,
      category: category
    });

    // Trigger refresh of bookmark list
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div className="bookmarks-page">
      <BookmarkList
        key={refreshTrigger}
        onCreateSynthesis={() => setShowCreateModal(true)}
      />

      <CreateSynthesis
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        onSave={handleCreateSynthesis}
      />
    </div>
  );
}

export default BookmarksPage;
